import { MapValueToBuffer } from "./MapValueToBuffer";

export class CodeSegment {
  tag: string;
  Id: string;
  Data: Uint8Array | undefined;
  Mask: Uint8Array | undefined;
  Address: number;
  MemoryType: any;
  size: number;
  LoadStateMachine: number;
  Offset: number;

  constructor(data: {
    tag: string;
    Id: string;
    Data: Uint8Array | undefined;
    Mask: Uint8Array | undefined;
    Address: number;
    MemoryType: any;
    size: number;
    LoadStateMachine: number;
    Offset: number;
  }) {
    this.tag = data.tag;
    this.Id = data.Id;
    this.Data = data.Data;
    this.Mask = data.Mask;
    this.Address = data.Address;
    this.MemoryType = data.MemoryType;
    this.size = data.size;
    this.LoadStateMachine = data.LoadStateMachine;
    this.Offset = data.Offset;
  }

  defaultMappings = new Array<MapValueToBuffer>();

  mappings = new Array<MapValueToBuffer>();

  debugDifferences(dataFromDevice: Uint8Array) {
    if (this.Data) {
      console.log("Difference: Param In Actual Device Memory (LEFT) vs Param In Estada (RIGHT): ");

      if (dataFromDevice.length != this.Data.length) {
        console.log(`size different ${dataFromDevice.length} != ${this.Data.length}`);
      }

      for (let i = 0; i < this.Data?.length; i++) {
        if (this.Data[i] != dataFromDevice[i]) {
          console.log(
            `${i}: ${dataFromDevice[i]} - ${this.Data[i]}   hex: ${dataFromDevice[i].toString(16)} - ${this.Data[i].toString(16)} string: "${String.fromCharCode(dataFromDevice[i])}" - "${String.fromCharCode(this.Data[i])}"`,
          );

          const mappings = this.findMappings(i);
          const defaultMappings = this.findDefaultMappings(i);

          console.log("this diff belongs to Parameters: ");
          defaultMappings.forEach((m) => {
            console.log(`id: ${m.propertyId}`);
          });
          if (defaultMappings.length == 0) {
            console.log("-- NO Parameter --");
          }

          console.log("this diff belongs to ParameterRefs: ");
          mappings.forEach((m) => {
            console.log(`id: ${m.propertyId} instanceId: ${m.instanceId}`);
          });
          if (defaultMappings.length == 0) {
            console.log("-- NO ParameterRef --");
          }
        }
      }
    }
  }

  findMappings(fullOffset: number) {
    return this.xFindMapping(this.mappings, fullOffset);
  }

  findDefaultMappings(fullOffset: number) {
    return this.xFindMapping(this.defaultMappings, fullOffset);
  }

  xFindMapping(mappings: Array<MapValueToBuffer>, fullOffset: number) {
    const res = this.mappings.filter((mapping) => {
      const end = mapping.fullOffset + Math.ceil(mapping.sizeInBit / 8);
      return mapping.fullOffset <= fullOffset && fullOffset < end;
    });

    return res;
  }
}
